import { FormSteps, formStepsState } from '@/store/formSteps';
import { FunctionSpaces, functionSpaceState } from '@/store/function_spaces';
import { Items, itemState } from '@/store/items';
import { Locations, locationsState } from '@/store/locations';
import { PackageDeals } from '@/store/package_deals';
import { Partner, partnerState } from '@/store/partner';
import { Reservation, reservationState } from '@/store/reservation';
import { RoomTypes, roomTypesState } from '@/store/room_types';
import { Emplacements, emplacementsState } from '@/store/emplacements';
import { InjectionKey } from 'vue';
import { createStore, useStore as baseUseStore, Store } from 'vuex';

export type State = {
  formSteps: formStepsState;
  items: itemState;
  locations: locationsState;
  partner: partnerState;
  reservation: reservationState;
  roomTypes: roomTypesState;
  emplacements: emplacementsState;
  functionSpaces: functionSpaceState;
};

export const store = createStore<State>({
  state: {} as State,
  mutations: {},
  actions: {},
  modules: {
    formSteps: FormSteps,
    items: Items,
    locations: Locations,
    packageDeals: PackageDeals,
    partner: Partner,
    reservation: Reservation,
    roomTypes: RoomTypes,
    emplacements: Emplacements,
    functionSpaces: FunctionSpaces,
  },
  strict: true,
});

export const key: InjectionKey<Store<State>> = Symbol();

export function useStore() {
  return baseUseStore(key);
}
